import { render, staticRenderFns } from "./ContenidoCursoCurricula.vue?vue&type=template&id=7903fb81&scoped=true"
import script from "./ContenidoCursoCurricula.vue?vue&type=script&lang=js"
export * from "./ContenidoCursoCurricula.vue?vue&type=script&lang=js"
import style0 from "./ContenidoCursoCurricula.vue?vue&type=style&index=0&id=7903fb81&prod&scoped=true&lang=css"
import style1 from "./ContenidoCursoCurricula.vue?vue&type=style&index=1&id=7903fb81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7903fb81",
  null
  
)

export default component.exports